import { FC, ReactElement } from "react";
import {
  CircularProgress,
  Grid,
  IconButton,
  Stack,
  SxProps,
  Typography,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";

import Modal from "..";
import { ContainerHeading, StyledContainedButton } from "./styles.tsx";
import { tokens } from "@/tokens";

interface ModalProps {
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  children: ReactNode[] | ReactNode;
  title: string;
  subTitle?: string;
  buttonText: string;
  buttonAction: () => void;
  isConfirmButtonLoading?: boolean;
  maxWidth?: "xs" | "sm" | "md" | "lg" | "xl";
  modalStyles?: React.CSSProperties | SxProps;
  buttonLoader?: boolean;
  hideActionButton?: boolean;
  hideCancelButton?: boolean;
}

const ActionModal: FC<ModalProps> = ({
  show,
  setShow,
  children,
  title,
  subTitle,
  buttonText,
  hideActionButton = false,
  buttonAction,
  isConfirmButtonLoading = false,
  modalStyles,
  maxWidth = "sm",
  hideCancelButton = false,
  buttonLoader = false,
}): ReactElement => {
  return (
    <Modal
      sx={modalStyles}
      open={show}
      onClose={() => setShow(false)}
      maxWidth={maxWidth}
      hideClose
    >
      <div>
        <ContainerHeading>
          <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
            <div>
              <Typography sx={{ fontSize: tokens.fontSize.xl, fontWeight: tokens.fontWeight.bold, color: tokens.text.primary, lineHeight: 1.3 }}>
                {title}
              </Typography>
              {subTitle && (
                <Typography sx={{ fontSize: tokens.fontSize.sm2, color: tokens.text.muted, mt: 0.5 }}>
                  {subTitle}
                </Typography>
              )}
            </div>
            <IconButton
              size="small"
              onClick={() => setShow(false)}
              sx={{ color: tokens.text.muted, '&:hover': { color: tokens.text.primary } }}
            >
              <CloseIcon sx={{ fontSize: 20 }} />
            </IconButton>
          </Stack>
        </ContainerHeading>
        {children}
        <Grid container spacing={1.5} sx={{ px: 3, pt: 0, pb: 3 }}>
          <Grid item xs={6}>
          {!hideCancelButton && (
            <StyledContainedButton
              disabled={isConfirmButtonLoading}
              size="large"
              title="Cancel"
              variant="outlined"
              onClick={() => setShow(false)}
            />
          )}
          </Grid>
          <Grid item xs={6}>
          {!hideActionButton && (
            <StyledContainedButton
              disabled={isConfirmButtonLoading || buttonLoader}
              size="large"
              title={buttonText}
              onClick={buttonAction}
              {...(isConfirmButtonLoading && {
                startIcon: (
                  <CircularProgress sx={{ color: "white" }} size={20} />
                ),
              })}
            />
          )}
            </Grid>
        </Grid>
      </div>
    </Modal>
  );
};

export default ActionModal;
